<template>
  <p-app theme="glittr">
    <template slot="header">
      <p-toolbar>
        <p-row align-center dense>
          <p-img :to="mobileRootUrl" class="ml-4" width="140" contain :src="require('@src/assets/logo.png')"></p-img>
        </p-row>
        <p-row justify-end align-items-center>
          <span class="language-selection-menu-wrapper pt-1 mr-2">
            <il-language-selection></il-language-selection>
          </span>
        </p-row>
      </p-toolbar>
    </template>
    <p-container class="fill-height">
      <slot class="content" />
    </p-container>
  </p-app>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    auth: true,
    data: () => ({
    }),
    computed: {
      siHaDocumentationShareId(): string | undefined {
        return this.$router.currentRoute?.params?.shareId as string | undefined;
      },
      mobileRootUrl(): string {
        return `/glaromat/il/siha/mobile?shareId=${this.siHaDocumentationShareId}`;
      },
    },
    mounted() {
    },
    methods: {
    },
  });
</script>
